import { Component, OnInit, ViewChild, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ApiService } from '../services/api.service';
import { AssignLotNumDialogComponent, AssignLotNumDialogData } from './assign-lot-num-dialog.component';

export interface PendingInventoryItem {
  purchaseOrderProductId: number;
  purchaseOrderId: number;
  purchaseOrderNumber?: string;
  orderDate?: string;
  vendorId: number;
  vendorName?: string;
  productId: number;
  productName?: string;
  catalogNum?: string;
  quantity: number;
  unitType?: string;
  vendorCatalogNum?: string;
  vendorLotNum?: string;
}

@Component({
  standalone: true,
  selector: 'app-pending-inventory',
  templateUrl: './pending-inventory.component.html',
  styleUrl: './pending-inventory.component.css',
  imports: [
    CommonModule,
    MatIconModule,
    MatTableModule,
    MatPaginatorModule,
    MatTooltipModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class PendingInventoryComponent implements OnInit {
  dataSource = new MatTableDataSource<PendingInventoryItem>([]);
  columns: string[] = ['purchaseOrderNumber', 'orderDate', 'vendorName', 'productName', 'catalogNum', 'vendorCatalogNum', 'quantity', 'unitType'];
  loading: boolean = true;
  error: string | null = null;

  @ViewChild(MatPaginator) set matPaginator(p: MatPaginator) {
    if (p) { this.dataSource.paginator = p; }
  }

  applyFilter(event: Event): void {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  constructor(
    private apiService: ApiService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    this.loadPendingInventory();
  }

  loadPendingInventory(): void {
    this.loading = true;
    this.error = null;

    this.apiService.get<any[]>('purchaseorder/pending-inventory').subscribe({
      next: (data) => {
        this.dataSource.data = (data || []).map(item => ({
          purchaseOrderProductId: item.purchaseOrderProductId || item.PurchaseOrderProductId || item.id || item.Id,
          purchaseOrderId:        item.purchaseOrder?.id              || item.purchaseOrder?.Id              || item.PurchaseOrder?.Id              || item.purchaseOrderId        || item.PurchaseOrderId,
          purchaseOrderNumber:    item.purchaseOrder?.number          || item.purchaseOrder?.Number          || item.PurchaseOrder?.Number          || item.purchaseOrderNumber    || item.PurchaseOrderNumber,
          orderDate:              item.purchaseOrder?.date            || item.purchaseOrder?.Date            || item.PurchaseOrder?.Date            || item.orderDate              || item.OrderDate,
          vendorId:               item.vendorProduct?.vendor?.id       || item.vendorProduct?.vendor?.Id       || item.VendorProduct?.Vendor?.Id       || item.vendorId    || item.VendorId,
          vendorName:             item.vendorProduct?.vendor?.name     || item.vendorProduct?.vendor?.Name     || item.VendorProduct?.Vendor?.Name     || item.vendorName  || item.VendorName,
          productId:              item.product?.id                || item.product?.Id                || item.Product?.Id                || item.productId              || item.ProductId,
          productName:            item.product?.name              || item.product?.Name              || item.Product?.Name              || item.productName            || item.ProductName,
          catalogNum:             item.product?.catalogNum        || item.product?.CatalogNum        || item.Product?.CatalogNum        || item.catalogNum             || item.CatalogNum,
          quantity:               item.quantity               ?? item.Quantity,
          unitType:               item.unitType               || item.UnitType,
          vendorCatalogNum:       item.vendorProduct?.catalogNum       || item.vendorProduct?.CatalogNum       || item.VendorProduct?.CatalogNum,
          vendorLotNum:           item.vendorLotNum            || item.VendorLotNum            || ''
        }));
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        console.error('Error loading pending inventory:', err);
        this.error = 'Failed to load pending inventory.';
        this.loading = false;
        this.cdr.detectChanges();
      }
    });
  }

  viewPurchaseOrder(item: PendingInventoryItem): void {
    const dialogRef = this.dialog.open(AssignLotNumDialogComponent, {
      width: '560px',
      disableClose: false,
      data: {
        purchaseOrderProductId: item.purchaseOrderProductId,
        purchaseOrderId:        item.purchaseOrderId,
        purchaseOrderNumber:    item.purchaseOrderNumber,
        productId:              item.productId,
        productName:            item.productName,
        catalogNum:             item.catalogNum,
        quantity:               item.quantity,
        unitType:               item.unitType,
        vendorId:               item.vendorId,
        vendorName:             item.vendorName,
        vendorCatalogNum:       item.vendorCatalogNum,
        vendorLotNum:           item.vendorLotNum
      } as AssignLotNumDialogData
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result?.assigned) {
        this.loadPendingInventory();
      }
    });
  }
}
